<template>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="crumb-wrap">
        <el-breadcrumb-item v-for="(route,index) in routes" :key="index" :to="goToPath(route,index)">
            {{ route.name }}
        </el-breadcrumb-item>
    </el-breadcrumb>
</template>

<script>
    import {getShopExamineInfo} from '../../api/shop'
    export default {
        name: 'crumb',
        data() {
            return {

            }
        },
        computed: {
            routes(){
                const matched = this.$route.matched;
                let list = [];
                for(let i = 0; i < matched.length ; i++ ) {
                    list.push({
                        name: matched[i].name,
                        path: matched[i].path
                    })

                }
                return list
            }
        },
        mounted(){
            console.log('route',this.$route);
        },
        methods: {
            goToPath( route, index ){
                if(route.name=='卖家工作台' && index == 0){
                    return;
//                    await getShopExamineInfo().then(res=>{
//                        if(res.data){
//                            if(res.data.status===0 ||res.data.status===2){
//                                return {}
//                            }
//                        }
//
//                    })
                }
                let path = route.path;
                if( path.indexOf(":") === -1 && index < this.routes.length ){
                    return { path: route.path }
                }else{
                    console.log('STOP ROUTE');
                    return {}
                }
            }
        }
    }
</script>

<style lang="scss">
    .crumb-wrap{
        padding:15px 0 20px;
    }
    .el-breadcrumb__inner a, .el-breadcrumb__inner.is-link{
        color:#5A5A5A;
        font-weight: 500;
        /*font-size:14px;*/
        &:hover{
            color:#5A5A5A;
        }
    }
    /*.el-breadcrumb__inner{*/
        /*font-size:14px;*/
    /*}*/
    .el-breadcrumb__item:last-child .el-breadcrumb__inner, .el-breadcrumb__item:last-child .el-breadcrumb__inner a, .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover, .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover{
        color:#5A5A5A;
        font-size:14px;
        /*line-height:20px;*/
    }
</style>